<template>
  <div class="PaB-app-search-form">
    <div class="PaB-search-input-field">
      <input type="text" v-model="searchTerm" placeholder="Search..." @keyup.enter="search">

      <app-button type="blank" :icon="true" @click.native="clearSearch" v-if="searchTerm">
        <template slot="after">
          <icon-base icon-name="Clear" width="15" height="15">
            <icon-close></icon-close>
          </icon-base>
        </template>
      </app-button>
    </div>

    <product-filters-dropdown />

    <app-button label="Search" classes="PaB-button--search" :icon="true" @click.native="search">
      <template slot="after">
        <icon-base icon-name="Search" width="20" height="20">
          <icon-search></icon-search>
        </icon-base>
      </template>
    </app-button>
  </div>
</template>

<style lang="scss">
.PaB-app-search-form .PaB-dropdown .PaB-dropdown-toggle {
  border-radius: 0;
}
</style>

<style lang="scss" scoped>
.PaB-search-input-field {
  display: flex;
  border: 1px solid #b2b2b2;
  border-right: 0;
  align-items: center;
  position: relative;
  flex: 1 1 auto;

  input {
    border: 0;
    outline: none;
    box-shadow: none;
    padding-right: 40px;
    width: 100%;
    height: 100%;
    padding: 10px;
    font-size: inherit;
  }

  .PaB-button {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    padding: 10px;
    border-radius: 0;
  }
}

.PaB-app-search-form {
  display: flex;
  flex-direction: row;
  position: relative;

  > :first-child {
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
  }

  > :last-child {
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
  }

  .PaB-button--search {
    border-left: 0;
    margin-left: -1px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .PaB-dropdown-toggle {
    border-left: 0;
    border-right-color: transparent;
  }

  .PaB-dropdown.is-open .PaB-dropdown-toggle {
    border-right-color: #b2b2b2;
  }
}
</style>

<script>
import ProductFiltersDropdown from '@/components/ProductFiltersDropdown'
import AppButton from '@/components/AppButton'
import IconBase from '@/components/IconBase'
import IconSearch from '@/components/icons/IconSearch'
import IconClose from '@/components/icons/IconClose'

export default {
  components: {
    ProductFiltersDropdown,
    AppButton,
    IconBase,
    IconSearch,
    IconClose
  },

  data: function () {
    return {
      searchTerm: ''
    }
  },

  created () {
    this.$store.watch((state) => {
      return this.$store.state.products.search // could also put a Getter here
    }, (newValue, oldValue) => {
      if (newValue !== this.searchTerm) {
        this.searchTerm = newValue
      }
    }, { deep: true })
  },

  methods: {
    search: function () {
      this.$store.dispatch('products/search', this.searchTerm)
      // route to all products if on home page
      const currentRoute = this.$router.currentRoute.fullPath
      if (currentRoute === '/') {
        this.$router.push({ name: 'product-listing', params: { category: 'all' } })
      }
    },
    clearSearch: function () {
      this.searchTerm = ''
      this.$store.dispatch('products/search', '')
    }
  }
}
</script>
